import { render } from "./LoadXMLModal.vue?vue&type=template&id=6f923fa3&scoped=true"
import script from "./LoadXMLModal.vue?vue&type=script&lang=js"
export * from "./LoadXMLModal.vue?vue&type=script&lang=js"

import "./LoadXMLModal.vue?vue&type=style&index=0&id=6f923fa3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f923fa3"]])

export default __exports__